import {
  GIBDD_TITLE,
  MANAGMENT_MANUFACTURING_ENTERPRISE_TITLE,
  NS_TITLE,
  SRR3_TITLE,
  SRR5_TITLE,
  SRR_TITLE_TO_MONTH_CONTROL,
  SRR_TITLE_TO_MONTH_CONTROL_SALES_PERIOD,
  UVIN_TITLE,
} from "~/pages/SRR/options";

export const getCustomTableHeaderForSRR = (
  valueReport,
  customHeaders,
  tableRows,
  groupSrr,
  rowTO,
  rowTO5,
  t
) => {
  switch (valueReport) {
    case "ReportReturnLoyaltyServiceByDealer":
      return customHeaders.ReportReturnLoyaltyServiceByDealer(
        valueReport,
        tableRows,
        t
      );
    case "ReportNSByDealer":
      return customHeaders.ReportNSByDealer(
        valueReport,
        tableRows,
        t,
        groupSrr["bonus"]
      );
    case "ReportNSByClient":
      return customHeaders.ReportNSByClient(valueReport, tableRows, t);
    case "ReportNSByWarmClients":
      return customHeaders.ReportNSByWarmClients(valueReport, tableRows, t);
    case "ReportNSByOldClients":
      return customHeaders.ReportNSByOldClients(valueReport, tableRows, t);
    case "ReportNSByClientCarSale":
      return customHeaders.ReportNSByClientCarSale(valueReport, tableRows, t);
    case "TOMonthOfControlMine":
      return customHeaders.TOMonthOfControlMine(
        valueReport,
        tableRows,
        t,
        groupSrr
      );
    case "TOOwnBySalesPeriod":
      return customHeaders.TOOwnBySalesPeriod(
        valueReport,
        tableRows,
        t,
        groupSrr
      );
    case "warrantyRepairMonthOfControl":
      return customHeaders.warrantyRepairMonthOfControl(
        valueReport,
        tableRows,
        t,
        groupSrr
      );
    case "TOMonthOfControlFriendOrFoe":
      return customHeaders.TOMonthOfControlFriendOrFoe(
        valueReport,
        tableRows,
        t,
        groupSrr
      );
    case "TOMonthOfControlFriendOrFoeByCarFamily":
      return customHeaders.TOMonthOfControlFriendOrFoeByCarFamily(
        valueReport,
        tableRows,
        t,
        groupSrr
      );
    case "TOFriendOrFoeBySalesPeriod":
      return customHeaders.TOFriendOrFoeBySalesPeriod(
        valueReport,
        tableRows,
        t,
        groupSrr
      );
    case "TOFriendOrFoeByPeriodByCarFamily":
      return customHeaders.TOFriendOrFoeByPeriodByCarFamily(
        valueReport,
        tableRows,
        t,
        groupSrr
      );
    case "warrantyRepairBySalesPeriod":
      return customHeaders.warrantyRepairBySalesPeriod(
        valueReport,
        tableRows,
        t,
        groupSrr
      );
    case "TOMonthOfControlCarFamilyRegion":
      return customHeaders.TOMonthOfControlCarFamilyRegion(
        valueReport,
        tableRows,
        t,
        groupSrr
      );
    case "ReportReturnCarServiceByDealer":
      return customHeaders.ReportReturnCarServiceByDealer(
        valueReport,
        tableRows,
        t,
        groupSrr
      );
    case "ReportReturnSRR3ForPayments":
      return customHeaders.ReportReturnSRR3ForPayments(
        valueReport,
        tableRows,
        t,
        groupSrr
      );
    case "ReportReturnSRR5ForPayments":
      return customHeaders.ReportReturnSRR5ForPayments(
        valueReport,
        tableRows,
        t,
        groupSrr
      );
    case "ReportReturnSRR3ByCar":
      return customHeaders.ReportReturnSRR3ByCar(
        valueReport,
        tableRows,
        t,
        groupSrr
      );
    case "ReportReturnSRR5ByCar":
      return customHeaders.ReportReturnSRR5ByCar(
        valueReport,
        tableRows,
        t,
        groupSrr
      );
    case "ReportReturnSRR3ByDealer":
      return customHeaders.ReportReturnSRR3ByDealer(
        valueReport,
        tableRows,
        t,
        groupSrr,
        rowTO
      );
    case "ReportReturnSRR5ByDealer":
      return customHeaders.ReportReturnSRR5ByDealer(
        valueReport,
        tableRows,
        t,
        groupSrr,
        rowTO5
      );
    default:
      return customHeaders.consultant(valueReport, tableRows, t);
  }
};

export const getSrrTitleTOMonthControl = (isSRRTitle) => {
  switch (isSRRTitle["value"]) {
    case "TOMonthOfControl":
      return {
        label: SRR_TITLE_TO_MONTH_CONTROL[0].label,
        value: SRR_TITLE_TO_MONTH_CONTROL[0].value,
      };
    case "SRR3":
      return {
        label: SRR3_TITLE[0].label,
        value: SRR3_TITLE[0].value,
      };
    case "SRR5":
      return {
        label: SRR5_TITLE[0].label,
        value: SRR5_TITLE[0].value,
      };
    case "RegistrationOfTrafficPolice":
      return {
        label: GIBDD_TITLE[0].label,
        value: GIBDD_TITLE[0].value,
      };
    case "reportReturnOfVehiclesForMaintenance":
      return {
        label: UVIN_TITLE[0].label,
        value: UVIN_TITLE[0].value,
      };
    case "AverageDailyMileageReport":
      return {
        label: NS_TITLE[0].label,
        value: NS_TITLE[0].value,
      };
    case "1c-ManagementManufacturingEnterprise":
      return {
        label: MANAGMENT_MANUFACTURING_ENTERPRISE_TITLE[0].label,
        value: MANAGMENT_MANUFACTURING_ENTERPRISE_TITLE[0].value,
      };
    default:
      return {
        label: SRR_TITLE_TO_MONTH_CONTROL_SALES_PERIOD[0].label,
        value: SRR_TITLE_TO_MONTH_CONTROL_SALES_PERIOD[0].value,
      };
  }
};
